import React, { Fragment } from "react";
import PropTypes from "prop-types";
import Form from "../../common/Form";
import Section from "../../common/Section";
import Table from "../../common/Table";
import Tooltip from "../../common/Tooltip";
import RelativeLink from "../../common/RelativeLink";
import ConfirmModal from "../../common/ConfirmModal";
import * as ComponentConstants from '../../../constants/ComponentConstants';
import { TochtRedenVanStatus } from "../../../constants/DomainConstants";
import moment from "moment";
import InSamenWerkingMetLogos from "../../common/InSamenWerkingMetLogos";
import Button from "../../common/Button";
import capitalize from "../../../util/stringFormatter";
import { getTochtTypeText, getStatusText, getStatusTooltipText } from "../../../util/tochtTypeHelper";
import { getIcoonDataUri } from "../../../util/tochtTypeIcoon";
import ToelatingenStatusTooltip from "./ToelatingenStatusTooltip";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEnvelope } from '@fortawesome/free-solid-svg-icons';

const VTTPerOrganisatorForm = (props) => {
	const {
		model,
		tochtTypes,
		onNew,
		disabled,
		modalIsOpen,
		modalEntityId,
		onModalOpen,
		onModalClose,
		onDelete,
		onMailOpmerkingen,
		getPdfDownloadUrl,
		deleteTochtTypeTekst
	} = props;

	const geplandeTableHeaders = ["TOCHT", "DATUM", "STATUS", "GOEDKEURINGEN", ""];
	const afgelopenTableHeaders = ["TOCHT", "DATUM", "STATUS", ""];
	const geplandeTableHeaderSizes = [29, 11, 28, 16, 16];
	const afgelopenTableHeaderSizes = [38, 11, 35, 16];
	const tochtTypeText = getTochtTypeText();

	const geplandeRows = model.tochtenGepland && model.tochtenGepland.length ? createRows(model.tochtenGepland, true) : null;
	const afgelopenRows = model.tochtenGereden && model.tochtenGereden.length ? createRows(model.tochtenGereden, false) : null;

	function mappedOnDelete(id) {
		return () => onDelete(id);
	}

	function mappedOnModalOpen(id, tochtTypeTekst) {
		return () => onModalOpen(id, tochtTypeTekst);
	}

	function onNewTocht() {
		return () => onNew();
	}

	function mailOpmerkingen() {
		return () => onMailOpmerkingen();
	}

	function getTochtTypeIcoon(tochtTypeId) {
		const tochtType = tochtTypes && tochtTypes.find(x => x.id === tochtTypeId);
		if (!tochtType || !tochtType.icoonBase64)
			return null;

		return <img className="tochttype-icoon" src={getIcoonDataUri(tochtType.icoonBase64)} title={tochtType.naam} alt={tochtType.naam} />;
	}

	function createRows(tochtenArray, toonIconen) {
		return tochtenArray.map((tocht) => {
			const commentaarBijAfgekeurd = tocht.commentaarDoorAfgekeurd ?
				<Tooltip
					text={tocht.commentaarDoorAfgekeurd}
					tooltipType={ComponentConstants.TOOLTIP_ERROR}
					iconColor={ComponentConstants.COLOR_RED}
					windowWidth={30} /> : null;
			const disabledStyle = { cursor: 'not-allowed', color: '#eeefef' };
			const trashStyle = tocht.uivEventId ? disabledStyle : null;
			const trashToolTip = tocht.uivEventId ? ComponentConstants.TOOLTIP_GEPUBLICEERDE_TOCHT_ANNULEREN : `verwijder ${tochtTypeText.TochtTypeSingular}`;

			const toelatingenIcoon = tocht.redenVanStatus === TochtRedenVanStatus.DoorgestuurdTerGoedkeuring && tocht.toelatingen && tocht.toelatingen.length ?
				<ToelatingenStatusTooltip toelatingen={tocht.toelatingen} /> : null;

			const toelatingenKolom = toonIconen ? <td className="center-text">{toelatingenIcoon}</td> : null;

			const conflictenTooltip = tocht.hasOpenGpxConflicten ?
				<Tooltip
					icon={ComponentConstants.TOOLTIP_ICON_EXCLAMATION_TRIANGLE}
					text={"Deze tocht is in conflict met 1 of meerdere tochten van andere organisatoren."}
					tooltipType={ComponentConstants.TOOLTIP_WARNING}
					iconColor={ComponentConstants.COLOR_ORANGE}
					windowWidth={30} /> : null;

			const statusTooltipText = toonIconen ? getStatusTooltipText(tocht.redenVanStatus, tocht.hasOpenGpxConflicten, tocht.hasOntbrekendeGpx) : null;
			const statusTooltip = statusTooltipText ?
				<Tooltip
					icon={ComponentConstants.TOOLTIP_ICON_INFO}
					text={statusTooltipText}
					tooltipType={ComponentConstants.TOOLTIP_INFO}
					iconColor={ComponentConstants.COLOR_BLUE_LIGHT_HEX}
					windowWidth={30} /> : null;

			return (
				<tr key={tocht.id}>
					<td>
						{getTochtTypeIcoon(tocht.tochtTypeId)} {tocht.svlDossierId} {tocht.naam} {conflictenTooltip}
					</td>
					<td>
						{moment(tocht.datum).format("DD/MM/YYYY")}
					</td>
					<td>
						{getStatusText(tocht.redenVanStatusNaam, tocht.redenVanStatus, tocht.hasOpenGpxConflicten, tocht.hasOntbrekendeGpx)}{statusTooltip}{commentaarBijAfgekeurd}
					</td>
					{toelatingenKolom}
					<td className="fit-content">
						<div className="tocht-actions">
							<RelativeLink to={"/e-loket/organisator/" + tocht.id + "/organisator" + "/" + tocht.verlopen} title={`detail ${tochtTypeText.TochtTypeSingular}`}><i className="fa fa-file-text-o fa-fw"></i></RelativeLink>

							<RelativeLink to={"/e-loket/veldtoertocht/clone/" + tocht.id} title={`Deze tocht opnieuw organiseren op een andere datum. De GPXen van deze tocht worden mee overgenomen.`}><i className="fa fa-clone fa-fw"></i></RelativeLink>

							{!tocht.verlopen ? <RelativeLink to={"/e-loket/" + "veldtoertochten"} title={trashToolTip}><span onClick={tocht.uivEventId ? null : mappedOnModalOpen(tocht.id, tochtTypeText.TochtTypeSingular)} style={{ fontSize: '1rem' }}><i style={trashStyle} className="fa fa-trash fa-fw"></i></span></RelativeLink> : null}
							{tocht.pdfGegenereerd ? <a href={getPdfDownloadUrl(tocht.id)} title="download pdf"><i className="fi flaticon-pdf"></i></a>
								: !tocht.verlopen ? <a title={ComponentConstants.TOOLTIP_GEEN_PDF_BESCHIKBAAR}><i style={disabledStyle} className="fi flaticon-pdf"></i></a> : null}
						</div>
					</td>
				</tr>
			);
		});
	}


	return (

		<Fragment>
			{modalIsOpen && <ConfirmModal
				isOpen={modalIsOpen}
				title={`${capitalize(deleteTochtTypeTekst)} annuleren en definitief verwijderen?`}
				mainText={`Ben je zeker dat je deze ${deleteTochtTypeTekst} wil annuleren en definitief verwijderen?`}
				confirmAction={mappedOnDelete(modalEntityId)}
				cancelAction={onModalClose}
				confirmText="Ja"
				cancelText="Nee" />}
			<Section
				classes="body-bg">
				<div className="header-buttons">
					<Button text="Contacteer Sport Vlaanderen" title="Contacteer Sport Vlaanderen" onClick={mailOpmerkingen()}>
						<FontAwesomeIcon icon={faEnvelope} />&nbsp;&nbsp;Contacteer Sport Vlaanderen
					</Button>
				</div>
			</Section>

			<Section
				id="geplandeTochten"
				title={"Geplande tochten"}
				color={"blue"}>
				<Form name="formGeplandeTochten"
					title={""}
					headerVisible={false}
					isNotRequired
					leftButtonLabel={"Voeg tocht toe"}
					onLeftButtonClick={onNewTocht()}
					leftButtonDisabled={disabled}>
					<Section>
						{(geplandeRows && geplandeRows.length > 0) ?
							<Table headers={geplandeTableHeaders} headerSizes={geplandeTableHeaderSizes}>
								{geplandeRows}
							</Table>
							:
							<p>Er zijn nog geen tochten toegevoegd</p>}
					</Section>
				</Form>
			</Section>

			{(afgelopenRows && afgelopenRows.length > 0) &&
				<Section
					id="afgelopenTochten"
					title={"Afgelopen tochten"}
					color={"red"}>
					<Section>
						<Table headers={afgelopenTableHeaders} headerSizes={afgelopenTableHeaderSizes}>
							{afgelopenRows}
						</Table>
					</Section>
				</Section>}
			<InSamenWerkingMetLogos />
		</Fragment>
	);
};

VTTPerOrganisatorForm.propTypes = {
	model: PropTypes.object.isRequired,
	tochtTypes: PropTypes.array,
	onNew: PropTypes.func,
	disabled: PropTypes.bool,
	readonly: PropTypes.bool,
	modalIsOpen: PropTypes.bool,
	modalEntityId: PropTypes.string,
	onModalOpen: PropTypes.func,
	onModalClose: PropTypes.func,
	onDelete: PropTypes.func,
	getPdfDownloadUrl: PropTypes.func,
	onMailOpmerkingen: PropTypes.func,
	deleteTochtTypeTekst: PropTypes.string
};

export default VTTPerOrganisatorForm;
